import { Box, IconButton, Input, Select, Td, Text, Tooltip, Tr } from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ClientClassificationType } from "models/client_classification_type";
import { CondicaoPagamento } from "models/condicao_pagamento_type";
import { OrderCategoryItem } from "models/order_category_item";
import { OSType } from "models/os_type";
import { PessoaType } from "models/person_type";
import { ProdutoItemType } from "models/product_item_type";
import { ProductType } from "models/product_type";
import { OptionType } from "models/select_mode";
import { useEffect, useState } from "react";
import { MdAdd, MdDelete, MdEdit } from "react-icons/md";
import formatNumber from "views/admin/order/hooks/formatNumber";
interface IAdmItemRow {
  item1: OSType;
  index1: number;
  index: number;
  produtos: ProductType[];
  unidades: ClientClassificationType[];
  fornecedor: PessoaType[];
  condicaoPagamento: CondicaoPagamento[];
  showFormPessoa: (show: boolean) => void;
  editPessoa: (item: PessoaType) => void;
  osList: OSType[];
  setOsList: React.Dispatch<React.SetStateAction<OSType[]>>;
  order: OrderCategoryItem;
  deleteOs: (id: string) => Promise<void>
  loading: boolean;
}

const AdmItemRow = ({
  item1,
  index1,
  index,
  produtos,
  unidades,
  condicaoPagamento,
  fornecedor,
  showFormPessoa,
  editPessoa,
  osList,
  setOsList,
  order,
  deleteOs,
  loading,
}: IAdmItemRow) => {

  const [selectedProduto, setSelectedProduto] = useState<ProductType>(null);
  const [selectedFornecedor, setSelectedFornecedor] = useState<PessoaType>(null);
  const [unidadesDisponiveis, setUnidadesDisponiveis] = useState<ClientClassificationType[]>([]);

  const updateItemInOsList = (value: Partial<OSType>) => {

    const newList = osList.map((item) => {
      if (item.osNum === item1.osNum && item.produtoId === item1.produtoId) {
        return {
          ...item,
          ...value,
        };
      }
      return item;
    });
    setOsList(newList);
  };

  const removeItemInOsList = (itemToRemove: OSType) => {
    if (itemToRemove.id) {
      deleteOs(itemToRemove.id);
      return;
    }

    const filteredList = osList.filter(
      (item) => !(item.osNum === itemToRemove.osNum && item.produtoId === itemToRemove.produtoId)
    );
  
    const groupedByProduct = filteredList.reduce((acc, item) => {
      acc[item.produtoId] = acc[item.produtoId] || [];
      acc[item.produtoId].push(item);
      return acc;
    }, {} as Record<string, OSType[]>);
  
    const reorderedList: OSType[] = Object.values(groupedByProduct).flatMap((group) =>
      group.map((item, index) => ({
        ...item,
        osNum: (index + 1),
      }))
    );
  
    setOsList(reorderedList);
  };  

  const changeUnidade = (item: string) => {
    const un = unidades?.find((val) => val.id === item);
    const prdUn = produtos?.find((value) => value.id === item1.produtoId);
    const selected = prdUn?.ProdutoUnidade.find(
      (prd) => prd?.unidadeMedidaId === item
    );
    if (selected) {
      const media = (Number(selected.valorMin) + Number(selected.valorMax)) / 2;
      const valorTotal = media * Number(item1.comercialQtd);

      updateItemInOsList({
        unidadeMedidaId: item,
        unidadeNome: un.nome,
        comercialValorUN: media,
        comercialTotal: valorTotal,
      });
    }
  };

  const changeFornecedor = (item: string) => {
    const selected = fornecedor?.find((f) => f.id === item);
    if (selected) {
      setSelectedFornecedor(selected);

      updateItemInOsList({
        pessoaId: selected.id,
      });
    }
  };

  const changePagamento = (item: string) => {
    const selected = condicaoPagamento?.find((f) => f.id === item);
    if (selected) {
      updateItemInOsList({
        condicaoPagamentoId: selected.id,
      });
    }
  };

  const changeQuantidade = (item: string) => {
    if (isNaN(Number(item))) return;

    const numericValue = Number(item);
    const novoTotal = numericValue * Number(item1.producaoValorUn);

    updateItemInOsList({
      comercialQtd: numericValue,
      comercialTotal: novoTotal,
    });
  };

  const changeQuantidadeTrabalho = (item: string) => {
    if (isNaN(Number(item))) return;

    const numericValue = Number(item);
    const novoTotal = numericValue * Number(item1.trabalhoValorUN);

    updateItemInOsList({
      trabalhoQtd: numericValue,
      trabalhoTotal: novoTotal,
    });
  };


  const changeQuantidadeProducao = (item: string) => {
    if (isNaN(Number(item))) return;

    const numericValue = Number(item);
    const novoTotal = numericValue * Number(item1.producaoValorUn);

    updateItemInOsList({
      producaoQtd: numericValue,
      producaoTotal: novoTotal,
    });
  };

  const changeValor = (item: string) => {
    if (isNaN(Number(item))) return;

    const numericValue = Number(item);

    updateItemInOsList({
      comercialValorUN: numericValue,
    });
  };

  const changeValorTrabalho = (item: string) => {
    if (isNaN(Number(item))) return;

    const numericValue = Number(item);

    updateItemInOsList({
      trabalhoValorUN: numericValue,
    });
  };

  const changeValorProducao = (item: string) => {
    if (isNaN(Number(item))) return;

    const numericValue = Number(item);

    updateItemInOsList({
      producaoValorUn: numericValue,
    });
  };

  const calculate = (item: string) => {
    let totalUn = Number(item);
    let total = totalUn * Number(item1.comercialQtd);

    updateItemInOsList({
      comercialTotal: total,
    });
  };

  const calculateTrabalho = (item: string) => {
    let totalUn = Number(item);

    let total = totalUn * Number(item1.trabalhoQtd);

    updateItemInOsList({
      trabalhoTotal: total,
    });
  };

  const calculateProducao = (item: string) => {
    let totalUn = Number(item);

    let total = totalUn * Number(item1.producaoQtd);

    updateItemInOsList({
      producaoTotal: total,
    });
  };

  useEffect(() => {
    if (item1 && produtos) {
      const prdUn = produtos?.find((value) => value.id === item1.produtoId);
      setSelectedProduto(prdUn);
      const unDisp: ClientClassificationType[] = [];
      unidades?.forEach((v) => {
        const existe = prdUn?.ProdutoUnidade.find(
          (un) => un.unidadeMedidaId === v.id
        );
        if (existe) {
          unDisp.push(v);
        }
      });

      setUnidadesDisponiveis(unDisp);
    }
  }, [item1, produtos, unidades, fornecedor]);

  return (
    <Tr>
      <Td>
        <IconButton
          colorScheme="red"
          variant="solid"
          borderRadius={8}
          isLoading={loading}
          isDisabled={item1.financeiroGerado}
          size={'sm'}
          icon={<MdDelete />}
          onClick={() => removeItemInOsList(item1)}
          aria-label={"Remover OS"}
        />
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={11}
          alignSelf={"center"}
        >
          {item1?.osNum}
        </Text>
      </Td>
      <Td>
        <Box width={200} alignSelf={"flex-start "}>
          <Box w={"100%"}>
            <Text
              textAlign="left"
              color={"black"}
              fontSize={15}
              alignSelf={"center"}
            >
              {selectedProduto?.nome}
            </Text>
          </Box>
        </Box>
      </Td>

      <Td>
        <Box width={360} alignSelf={"flex-start"}>
          <Box w={"76%"}>
            <AutoComplete<OptionType, false, GroupBase<OptionType>>
              size={"sm"}
              onChange={(e) => changeFornecedor(e.value)}
              placeholder="Fornecedor"
              isDisabled={false}
              name={"fornecedor"}
              value={{
                label: fornecedor?.find((f) => f.id === item1?.pessoaId)?.nome,
                value: item1?.pessoaId,
              }}
              options={fornecedor?.map((item) => {
                return {
                  label: item?.nome,
                  value: item?.id,
                };
              })}
            />
          </Box>
          <IconButton
            colorScheme="brand"
            variant="solid"
            mt={-8}
            borderRadius={8}
            mr={10}
            size={'sm'}
            icon={<MdAdd />}
            onClick={() => showFormPessoa(true)}
            float={"right"}
            aria-label={"Adicionar Cliente"}
          />
          <IconButton
            colorScheme="brand"
            variant="solid"
            size={'sm'}
            mt={-8}
            borderRadius={8}
            icon={<MdEdit />}
            onClick={() => {
              editPessoa(selectedFornecedor);
            }}
            float={"right"}
            aria-label={"Editar Contato"}
          />
        </Box>
      </Td>

      <Td>

        <Select
          size={"xs"}
          onChange={(e) => changePagamento(e.target.value)}
          value={item1?.condicaoPagamentoId || ""}
          style={{
            width: 150,
          }}
          name={`condicaoPagamento-${index1}-${index}`}
        >
          <option value="" disabled>
            Selecione
          </option>
          {condicaoPagamento.map((item) => (
            <option value={item?.id}>{item?.nome}</option>
          ))}
        </Select>
      </Td>

      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={11}
          alignSelf={"center"}
        >
          {item1.status}
        </Text>
      </Td>
      <Td>
        <Select
          size={"xs"}
          onChange={(e) => changeUnidade(e.target.value)}
          isDisabled={false}
          style={{
            width: 80,
          }}
          name={`unidade-${index1}-${index}`}
          value={item1.unidadeMedidaId || ""}
        >
          <option value="" disabled>
            Selecione
          </option>
          {unidadesDisponiveis.map((item) => (
            <option value={item?.id}>{item?.nome}</option>
          ))}
        </Select>
      </Td>
      <Td>
        <Input
          style={{
            width: 60,
          }}
          fontSize={11}
          size={"xs"}
          name={`quantidade--${index1}-${item1.comercialQtd}`}
          value={Number(item1.comercialQtd)}
          onChange={(e) => changeQuantidade(e.target.value)}
        />
      </Td>
      <Td>
        {/* <Tooltip
          label={`O valor deve ser entre ${formatNumber(
            isNaN(Number(selectedProdutoItens?.valorMin))
              ? 0
              : formatNumber(Number(selectedProdutoItens?.valorMin))
          )} e ${formatNumber(
            isNaN(Number(selectedProdutoItens?.valorMax))
              ? 0
              : formatNumber(Number(selectedProdutoItens?.valorMax))
          )}`}
        > */}
        <Input
          name={`valor--${index1}-${item1.comercialValorUN}`}
          value={item1.comercialValorUN}
          style={{
            width: 80,
          }}
          size={"xs"}
          onChange={(e) => changeValor(e.target.value)}
          onBlur={(e) => {
            if (Number(e.target.value) > 0) {
              calculate(e.target.value);
            }
          }}
        />
        {/* </Tooltip> */}
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={10}
          alignSelf={"center"}
        >
          {formatNumber(Number(item1.comercialTotal))}
        </Text>
      </Td>
      <Td>
        <Input
          style={{
            width: 60,
          }}
          fontSize={11}
          size={"xs"}
          name={`quantidadetrabalho--${index1}-${item1.trabalhoQtd}`}
          value={Number(item1.trabalhoQtd)}
          onChange={(e) => changeQuantidadeTrabalho(e.target.value)}
        />
      </Td>
      <Td>


        <Input
          name={`valorTrabalho--${index1}-${item1.trabalhoValorUN}`}
          value={item1.trabalhoValorUN}
          style={{
            width: 80,
          }}
          size={"xs"}
          onChange={(e) => changeValorTrabalho(e.target.value)}
          onBlur={(e) => {
            if (Number(e.target.value) > 0) {
              calculateTrabalho(e.target.value)
            }
          }}
        />

      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={10}
          alignSelf={"center"}
        >
          {formatNumber(Number(item1.trabalhoTotal))}
        </Text>
      </Td>
      <Td>
        <Input
          style={{
            width: 60,
          }}
          fontSize={11}
          size={"xs"}
          name={`quantidadeProducao--${index1}-${item1.producaoQtd}`}
          value={Number(item1.producaoQtd)}
          onChange={(e) => changeQuantidadeProducao(e.target.value)}
        />
      </Td>
      <Td>
        {/* <Tooltip
          label={`O valor deve ser entre ${formatNumber(
            isNaN(Number(selectedProdutoItens?.valorMin))
              ? 0
              : formatNumber(Number(selectedProdutoItens?.valorMin))
          )} e ${formatNumber(
            isNaN(Number(selectedProdutoItens?.valorMax))
              ? 0
              : formatNumber(Number(selectedProdutoItens?.valorMax))
          )}`}
        > */}
        <Input
          name={`valorProducao--${index1}-${item1.producaoValorUn}`}
          value={item1.producaoValorUn}
          style={{
            width: 80,
          }}
          size={"xs"}
          onChange={(e) => changeValorProducao(e.target.value)}
          onBlur={(e) => {
            if (Number(e.target.value) > 0) {
              calculateProducao(e.target.value)
            }
          }}
        />
        {/* </Tooltip> */}
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={10}
          alignSelf={"center"}
        >
          {formatNumber(Number(item1.producaoTotal))}
        </Text>
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={10}
          alignSelf={"center"}
        >
          {formatNumber(Number(item1.executado))}
        </Text>
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={10}
          alignSelf={"center"}
        >
          {formatNumber(Number(item1.pago))}
        </Text>
      </Td>
      <Td>
        <Text
          textAlign="left"
          color={"black"}
          fontSize={10}
          alignSelf={"center"}
        >
          {formatNumber(Number(item1.saldo))}
        </Text>
      </Td>
    </Tr>
  );
};
export default AdmItemRow;
